import React from "react";
import { Form, Checkbox, Input, Row, Col } from "antd";
import "../BusinessSignupForm.css";

const Section5 = ({ formValues, setFormValues }) => {
  const shouldShowAgeGroups = () => {
    const lifeStageSelections = formValues.lifeStage || [];
    const householdSelections = formValues.household || [];

    return (
      lifeStageSelections.length > 0 ||
      householdSelections.includes("Families with children") ||
      householdSelections.includes("Single individuals")
    );
  };

  const renderCheckboxGrid = (options, value, onChange) => (
    <Checkbox.Group value={value || []} onChange={onChange} style={{ width: "100%" }}>
      <Row gutter={[0, 8]}>
        {options.map((item) => (
          <Col span={12} key={item}>
            <Checkbox value={item}>{item}</Checkbox>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  );

  return (
    <Form layout="vertical">
      <h2 style={{ marginBottom: "20px", color: "#333" }}>
        Section 5 - Audience Targeting
      </h2>

      {/* Q19 – Audience Types */}
      <Form.Item label="19. Who are you primarily trying to reach? (Select all that apply)">
        <h4>Gender</h4>
        {renderCheckboxGrid(
          ["Men", "Women", "All genders"],
          formValues.gender,
          (checked) => setFormValues({ ...formValues, gender: checked })
        )}

        <h4 style={{ marginTop: "16px" }}>Household Type</h4>
        {renderCheckboxGrid(
          [
            "Single individuals",
            "Married couples",
            "Divorced or widowed",
            "Families with children",
            "Families without children",
          ],
          formValues.household,
          (checked) => setFormValues({ ...formValues, household: checked })
        )}

        <h4 style={{ marginTop: "16px" }}>Life Stage / Behavior</h4>
        {renderCheckboxGrid(
          [
            "Young professionals",
            "College students / recent graduates",
            "Parents with young children",
            "Seniors (55+)",
            "Empty nesters",
            "Remote workers / homebased professionals",
            "New or repeat business customers",
          ],
          formValues.lifeStage,
          (checked) => setFormValues({ ...formValues, lifeStage: checked })
        )}
      </Form.Item>

      {/* Q20 – Age Groups (conditional) */}
      {shouldShowAgeGroups() && (
        <Form.Item label="20. What age group(s) are you trying to reach? (Select all that apply)">
          {renderCheckboxGrid(
            [
              "11 and under",
              "12-18",
              "19-24",
              "25-34",
              "35-44",
              "45-54",
              "55-64",
              "65-74",
              "75+",
              "All ages",
              "Not sure",
            ],
            formValues.ageGroups,
            (checked) => setFormValues({ ...formValues, ageGroups: checked })
          )}
        </Form.Item>
      )}

      {/* Q21 – Racial / Ethnic Groups */}
      <Form.Item label="21. Are you targeting any specific racial or ethnic groups?">
        {renderCheckboxGrid(
          [
            "White / Caucasian",
            "Black / African American",
            "Hispanic / Latino",
            "Asian",
            "American Indian / Alaska Native",
            "Native Hawaiian / Other Pacific Islander",
            "Other",
            "Not sure",
            "All groups equally",
          ],
          formValues.ethnicGroups,
          (checked) => setFormValues({ ...formValues, ethnicGroups: checked })
        )}

        {/* ✅ Text input if "Other" selected */}
        {formValues.ethnicGroups?.includes("Other") && (
          <Input
            placeholder="Please specify other group"
            style={{ marginTop: 8 }}
            value={formValues.ethnicGroupsOther || ""}
            onChange={(e) =>
              setFormValues({ ...formValues, ethnicGroupsOther: e.target.value })
            }
          />
        )}
      </Form.Item>
    </Form>
  );
};

export default Section5;
